import { Component } from '@angular/core';

@Component({
  selector: 'app-empty-cms',
  template: '',
})
export class EmptyCms {}
